import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface HexacoServiceTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HexacoServiceTermsModal: React.FC<HexacoServiceTermsModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay bg="blackAlpha.400" />
      <ModalContent borderRadius="xl" mx={4}>
        <ModalHeader pr={12} fontSize="lg">
          {t("hexaco.purchase.terms.link")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={2}>
          <Text fontSize="sm" color="gray.700" lineHeight="tall" whiteSpace="pre-wrap">
            {t("hexaco.purchase.terms.body")}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="teal" borderRadius="full" onClick={onClose}>
            {t("hexaco.purchase.terms.close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default HexacoServiceTermsModal;
